import React from 'react';
import { useNavigate } from 'react-router-dom';

interface SidebarProps {
  currentTab: string;
  isConnected: boolean;
  displayName: string;
  onLogout: () => void;
}

const nav = [
  { id: 'overview',          label: 'Widget',   path: '/dashboard/overview' },
  { id: 'youtube/settings',  label: 'Settings', path: '/dashboard/youtube/settings' },
  { id: 'youtube/queue',     label: 'Queue',    path: '/dashboard/youtube/queue' },
];

const Sidebar: React.FC<SidebarProps> = ({ currentTab, displayName, onLogout }) => {
  const navigate = useNavigate();

  const active = (id: string) =>
    currentTab === id || currentTab.startsWith(id);

  return (
    <div style={{
      width: 160,
      minHeight: '100vh',
      background: '#fff',
      borderRight: '1px solid #e5e5e5',
      display: 'flex',
      flexDirection: 'column',
      padding: '24px 0',
    }}>
      <div style={{ padding: '0 16px 24px', fontWeight: 600, fontSize: 15, color: '#111' }}>
        Stream Tools
      </div>

      <nav style={{ flex: 1 }}>
        {nav.map(({ id, label, path }) => (
          <button
            key={id}
            onClick={() => navigate(path)}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '8px 16px',
              fontSize: 14,
              background: active(id) ? '#f3f0f9' : 'transparent',
              color: active(id) ? '#6441a5' : '#555',
              fontWeight: active(id) ? 500 : 400,
              border: 'none',
              cursor: 'pointer',
              borderLeft: active(id) ? '2px solid #6441a5' : '2px solid transparent',
            }}
          >
            {label}
          </button>
        ))}
      </nav>

      <div style={{ padding: '0 16px', borderTop: '1px solid #e5e5e5', paddingTop: 16 }}>
        <div style={{ fontSize: 13, color: '#111', fontWeight: 500, marginBottom: 8 }}>{displayName}</div>
        <button
          onClick={onLogout}
          style={{ fontSize: 12, color: '#888', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
